import { render, staticRenderFns } from "./digitCockpit1.vue?vue&type=template&id=24f7d444&scoped=true"
import script from "./digitCockpit1.vue?vue&type=script&lang=js"
export * from "./digitCockpit1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7d444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f7d444')) {
      api.createRecord('24f7d444', component.options)
    } else {
      api.reload('24f7d444', component.options)
    }
    module.hot.accept("./digitCockpit1.vue?vue&type=template&id=24f7d444&scoped=true", function () {
      api.rerender('24f7d444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/digitCockpit/digitCockpit1.vue"
export default component.exports